
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfigPerUrlQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sitename"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"globalSettings"},"name":{"kind":"Name","value":"getConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"sitename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sitename"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"afterContentDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"afterContentMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"afterNavigationDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"afterNavigationMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"beforeInlineSubsDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"beforeInlineNewsletterDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"beforeInlineSubsMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"beforeInlineNewsletterMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"beforeDigitekaDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"beforeDigitekaMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineItemBlacklist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listGalleryAds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"minNumOfWordsAfterLastInlineAdDesktop"},"name":{"kind":"Name","value":"lastInlineDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"minNumOfWordsAfterLastInlineAdMobile"},"name":{"kind":"Name","value":"lastInlineMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"minNumOfWordsBeforeTeads"},"name":{"kind":"Name","value":"teadsDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"numberOfWordsBetweenInlineDesktopAds"},"name":{"kind":"Name","value":"betweenInlineDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"numberOfWordsBetweenInlineMobileAds"},"name":{"kind":"Name","value":"betweenInlineMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"numberOfWordsForFirstInjectionDesktop"},"name":{"kind":"Name","value":"beforeInlineDesktopAds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"numberOfWordsForFirstInjectionMobile"},"name":{"kind":"Name","value":"beforeInlineMobileAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refreshBlacklist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refreshSiteWide"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refreshTime"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1028}};
    doc.loc.source = {"body":"query ConfigPerUrlQuery($url: String, $sitename: String) {\n  globalSettings: getConfig(url: $url, sitename: $sitename) {\n    adSettings {\n      afterContentDesktopAds\n      afterContentMobileAds\n      afterNavigationDesktopAds\n      afterNavigationMobileAds\n      beforeInlineSubsDesktopAds\n      beforeInlineNewsletterDesktopAds\n      beforeInlineSubsMobileAds\n      beforeInlineNewsletterMobileAds\n      beforeDigitekaDesktopAds\n      beforeDigitekaMobileAds\n      lineItemBlacklist\n      listGalleryAds\n      minNumOfWordsAfterLastInlineAdDesktop: lastInlineDesktopAds\n      minNumOfWordsAfterLastInlineAdMobile: lastInlineMobileAds\n      minNumOfWordsBeforeTeads: teadsDesktopAds\n      numberOfWordsBetweenInlineDesktopAds: betweenInlineDesktopAds \n      numberOfWordsBetweenInlineMobileAds: betweenInlineMobileAds\n      numberOfWordsForFirstInjectionDesktop: beforeInlineDesktopAds\n      numberOfWordsForFirstInjectionMobile: beforeInlineMobileAds\n      refreshBlacklist\n      refreshSiteWide\n      refreshTime\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ConfigPerUrlQuery"] = oneQuery(doc, "ConfigPerUrlQuery");
        
